export const cardButtonsIllustrations = {
  illustration_intermittent: 'assets/illustration_intermittent·e.svg',
  illustration_artiste_auteur: 'assets/illustration_artiste_auteur·e.svg',
  illustration_pigiste: 'assets/illustration_pigiste.svg',
  illustration_regime_general: 'assets/illustration_regime_general.svg',
  illustration_extra: 'assets/illustration_extra.svg',
} as const;

export const featureCardsIllustrations = {
  illustration_activites_et_documents: 'assets/illustration_activites_et_documents.svg',
  illustration_notes_de_droits_auteur: 'assets/illustration_notes_de_droits_auteur·e.svg',
  illustration_notes_de_frais: 'assets/illustration_notes_de_frais.svg',
  illustration_suivi_de_ma_situation: 'assets/illustration_suivi_de_ma_situation.svg',
  illustration_movinmotion_talents: 'assets/illustration_movinmotion_talents.svg',
} as const;

export const adminIllustrations = {
  illustration_back_office_administration: 'assets/illustration_back_office_administration.svg',
  illustration_back_office_gs: 'assets/illustration_back_office_gs.svg',
} as const;

export const authIllustrations = {
  illustration_change_password: 'assets/illustration_change_password.svg',
  illustration_sign_in: 'assets/illustration_sign-in.svg',
  illustration_check: 'assets/illustration_check.svg',
  illustration_envelope: 'assets/illustration_envelope.svg',
  illustration_Lock: 'assets/illustration_lock.svg',
  illustration_user: 'assets/illustration_user.svg',
};

// illustrations pour le futur widget file (MOV-16937)
export const fileIllustrations = {
  illustration_documents: 'assets/illustration_documents.svg',
  illustration_contract: 'assets/illustration_contract.svg',
} as const;

// illustrations pour le futur widget notification-center (MOV-16934)
export const notificationCenterIllustrations = {
  illustration_accessibility: 'assets/illustration_accessibility.svg',
  illustration_accessible: 'assets/illustration_accessible.svg',
  illustration_approval_delegation: 'assets/illustration_approval_delegation.svg',
  illustration_article_person: 'assets/illustration_article_person.svg',
  illustration_editor_choice: 'assets/illustration_editor_choice.svg',
  illustration_logo_film_france: 'assets/illustration_logo_film_france.svg',
  illustration_logo_talents: 'assets/illustration_logo_talents.svg',
  illustration_without_notification: 'assets/illustration_without_notification.svg',
  illustration_work_alert: 'assets/illustration_work_alert.svg',
} as const;

export const itemCookieIllustrations = {
  illustration_mixpanel: 'assets/illustration_mixpanel.svg',
} as const;

export type CardButtonIllustrationKey = keyof typeof cardButtonsIllustrations;
export const cardButtons = Object.keys(cardButtonsIllustrations) as CardButtonIllustrationKey[];

export type FeatureCardsIllustrationKey = keyof typeof featureCardsIllustrations;
export const featureCards = Object.keys(featureCardsIllustrations) as FeatureCardsIllustrationKey[];

export type AuthIllustrationKey = keyof typeof authIllustrations;
export const authent = Object.keys(authIllustrations) as AuthIllustrationKey[];

export type AdminIllustrationKey = keyof typeof adminIllustrations;
export const admins = Object.keys(adminIllustrations) as AdminIllustrationKey[];

export type FileIllustrationKey = keyof typeof fileIllustrations;
export const file = Object.keys(fileIllustrations) as FileIllustrationKey[];

export type NotificationCenterIllustrationKey = keyof typeof notificationCenterIllustrations;
export const notificationCenter = Object.keys(notificationCenterIllustrations) as NotificationCenterIllustrationKey[];

export type ItemCookieKey = keyof typeof itemCookieIllustrations;
export const itemCookie = Object.keys(itemCookieIllustrations) as ItemCookieKey[];

export const allIllustrations = {
  ...cardButtonsIllustrations,
  ...featureCardsIllustrations,
  ...adminIllustrations,
  ...authIllustrations,
  ...fileIllustrations,
  ...notificationCenterIllustrations,
  ...itemCookieIllustrations,
} as const;
